import { MapArtifactToSlides } from 'interfaces/jobs/basic';

interface PlotParam {
  id: string;
}

export interface ScatterPlotParams extends PlotParam {
  plotType: 'scatter';
  xAxis: string;
  yAxis: string;
  includeTrendline?: boolean;
}

export interface HistogramPlotParams extends PlotParam {
  plotType: 'histogram';
  column: string;
  bins?: number;
}

export interface BoxPlotParams extends PlotParam {
  plotType: 'box';
  columns: string[];
}

export interface ViolinPlotParams extends PlotParam {
  plotType: 'violin';
  columns: string[];
}

export interface PieChartParams extends PlotParam {
  plotType: 'pie';
  column: string;
}

export interface QuantificationAnalysisPlotsParams extends PlotParam {
  plotType: 'quantification_analysis';
}

export type FeaturesPlotParams =
  | ScatterPlotParams
  | HistogramPlotParams
  | BoxPlotParams
  | ViolinPlotParams
  | PieChartParams;

export type QuantificationPlotParams = QuantificationAnalysisPlotsParams;

export type ConfigurablePlotParams = FeaturesPlotParams | QuantificationPlotParams;

export interface ConfigurablePlots {
  plotName: string;
  plotList: Array<ConfigurablePlotParams>;
}

export interface GenerateStudyReportJobConfig {
  pipsCellsTablesArtifactUrls: MapArtifactToSlides[];
  markers: string[];
  manifest: string[];
  configurablePlots: ConfigurablePlots[];
}

export interface GenerateStudyReportFormValues {
  jobName: string;
  jobDescription: string;
  configParams: GenerateStudyReportJobConfig;
}

export enum GenerateStudyReportStep {
  NameAndDescription = 'Name and Description',
  SelectInferenceModels = 'Select Post Processing - Cell Typing',
  AdditionalParameters = 'Additional Parameters',
  AnalysisPlots = 'Analysis Plots',
}

export const createAnalysisStudioOrder = [
  GenerateStudyReportStep.NameAndDescription,
  GenerateStudyReportStep.SelectInferenceModels,
  GenerateStudyReportStep.AdditionalParameters,
  GenerateStudyReportStep.AnalysisPlots,
];
